import axios from 'axios';
import { useIAMResource } from './useIAMResource';

/**
 * Minimal user identity for owner-picker UI. Backed by GET /api/users/search
 * (registry/api/user_search_routes.py) -- unlike useIAMUsers, this works for
 * any authenticated user, not just admins, since it's used by non-admin
 * flows like the Register form's required Owner field.
 */
export interface SearchableUser {
  username: string;
  email?: string;
}

export function useUserSearch(search?: string) {
  const { data, isLoading, error, refetch } = useIAMResource<SearchableUser>(
    async () => {
      const params: Record<string, string | number> = { limit: 25 };
      if (search) params.search = search;
      const res = await axios.get('/api/users/search', { params });
      return res.data.users || [];
    },
    'Failed to search users',
    search ?? '',
  );
  return { users: data, isLoading, error, refetch };
}
